











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Apps from '@/store/modules/Apps';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Users from '@/store/modules/Users';
import CardDesignMainPage from '@/components/apps/CardDesignMainPage.vue';
import { API, Storage } from 'aws-amplify';

const usersModule = getModule(Users);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const appModule = getModule(Apps);

@Component({
    name: 'AppletGallery',
    components: {
        CardDesignMainPage
    },
    directives: {},
})

export default class AppletGallery extends Vue {
    @Prop({default: false, type: Boolean})
    embedApplet!: boolean;
    
}
